import { Component, Input, OnInit } from '@angular/core';
import { BaseDetailPageComponent } from '../../../components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from '../../../models/base-detail-page.config';
import ApiOptionsConfig from '../../../services/api/api-options.config';
import { UserService } from '../../../services/api/user.service';
import { ActivatedRoute } from '@angular/router';
import { FormProfileCompanyComponent } from '../components/profile-company/profile-company-form.component';
import { User } from '../../../models/entities/users';
import { RouteService } from '../../../services/route.service';

@Component({
  selector: 'app-users-detail-page',
  imports: [BaseDetailPageComponent, FormProfileCompanyComponent],
  templateUrl: './users-detail-page.component.html',
  styleUrl: './users-detail-page.component.scss'
})
export class UsersDetailPageComponent implements OnInit {
  
  baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail:boolean

  user?: User;

  constructor(
    private userService: UserService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Users',
      cardTitle: 'User Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit User',
        onClick: () => {
          if (this.user?.userId !== undefined) {
            this.routeService.userUpdate(this.user.userId);
          }
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'userId',
            label: 'ID',
            value: (item: any) => {
              return item.userId;
            }
          },
          {
            attribute: 'firstName',
            label: 'First name',
            value: (item: any) => {
              return item.firstName;
            }
          },
          {
            attribute: 'lastName',
            label: 'Last name',
            value: (item: any) => {
              return item.lastName;
            }
          },
          {
            attribute: 'email',
            label: 'Email',
            value: (item: any) => {
              return item.email;
            }
          },
        ]
      },
      apiDetailService: (userId: number) => this.userService.detail(userId),
      routeParamName: 'userId',
      responseModelName: 'user'
    }    

  }

  onLoadedDetail(data: any) {
    this.user = data;
  }
}
